import type { GradeQuizAnswerRow } from "./grade-quiz-response";
import type { QuizQuestionFormat } from "./quiz-question-format";
import type {
	QuizGradeFeedback,
	QuizGradeMethod,
	QuizGradeOutcome,
	QuizGradePart,
	QuizGradeResult,
} from "./quiz-grade-result";
import type { QuizResponsePayload } from "./quiz-response-payload";
import { resolveQuizResponseAnswerId } from "./resolve-quiz-response-answer-id";

export interface BuildQuizResponseWriteFieldsParams {
	questionFormat: QuizQuestionFormat;
	response: QuizResponsePayload;
	answers: GradeQuizAnswerRow[];
	grade: QuizGradeResult;
}

export interface QuizResponseWriteFields {
	questionFormat: QuizQuestionFormat;
	responsePayload: QuizResponsePayload;
	answerId: string | null;
	/** Derived: grade.outcome === "correct" */
	isCorrect: boolean;
	gradeOutcome: QuizGradeOutcome;
	gradeScore: number;
	gradeMethod: QuizGradeMethod;
	gradeParts: QuizGradePart[] | null;
	gradeFeedback: QuizGradeFeedback | null;
}

export function buildQuizResponseWriteFields(
	params: BuildQuizResponseWriteFieldsParams,
): QuizResponseWriteFields {
	let answerId: string | null = params.grade.matchedAnswerId;
	if (!answerId) {
		try {
			answerId = resolveQuizResponseAnswerId(
				params.answers,
				params.response,
			);
		} catch {
			answerId = null;
		}
	}
	return {
		questionFormat: params.questionFormat,
		responsePayload: params.response,
		answerId,
		isCorrect: params.grade.outcome === "correct",
		gradeOutcome: params.grade.outcome,
		gradeScore: params.grade.score,
		gradeMethod: params.grade.method,
		gradeParts: params.grade.parts ?? null,
		gradeFeedback: params.grade.feedback ?? null,
	};
}
